/* Blemoré Skincare — interacțiunile temei. Fără dependențe externe. */
(function () {
  "use strict";

  var CFG = window.blemore || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------------------------------------------------------------- utile */

  var scrollLock = (function () {
    var count = 0;
    var savedY = 0;
    return {
      on: function () {
        if (count === 0) {
          savedY = window.scrollY;
          var b = document.body;
          b.style.position = "fixed";
          b.style.top = "-" + savedY + "px";
          b.style.left = "0";
          b.style.right = "0";
          b.style.width = "100%";
          b.style.overflow = "hidden";
        }
        count++;
      },
      off: function () {
        count = Math.max(0, count - 1);
        if (count === 0) {
          var b = document.body;
          b.style.position = "";
          b.style.top = "";
          b.style.left = "";
          b.style.right = "";
          b.style.width = "";
          b.style.overflow = "";
          /* Site-ul are scroll-behavior: smooth, deci revenirea la pozitie ar fi
             animata din capul paginii pana jos, ca o aruncatura. O facem
             instantanee, ca inchiderea sertarului sa nu se vada deloc. */
          var html = document.documentElement;
          var comportament = html.style.scrollBehavior;
          html.style.scrollBehavior = "auto";
          window.scrollTo(0, savedY);
          html.style.scrollBehavior = comportament;
        }
      }
    };
  })();

  function toast(message) {
    var box = $("#toast");
    if (!box) return;
    var p = box.querySelector("p");
    p.textContent = message;
    box.classList.remove("hidden");
    box.classList.add("flex");
    clearTimeout(box._t);
    box._t = setTimeout(function () {
      box.classList.add("hidden");
      box.classList.remove("flex");
    }, 2600);
  }

  function money(cents) {
    var value = (cents / 100).toLocaleString("ro-RO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var format = CFG.moneyFormat || "{{amount_with_comma_separator}} lei";
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function esc(s) {
    return String(s === undefined || s === null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function thumb(url, w) {
    if (!url) return "";
    return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, wait);
    };
  }

  /* ------------------------------------------------------- scroll reveal */

  function initReveal() {
    var items = $$(".reveal");
    if (!items.length) return;
    if (!("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    /* Ce se vede deja la incarcare nu are de ce sa astepte observatorul.
       Fara asta, pe telefon prima sectiune apare goala cateva sute de
       milisecunde, cat dureaza pana ruleaza scriptul. */
    items.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 1.6) {
        el.classList.add("is-visible");
      }
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.01, rootMargin: "0px 0px 22% 0px" });
    items.forEach(function (el) { io.observe(el); });
    // plasă de siguranță, conținutul nu rămâne niciodată ascuns
    setTimeout(function () {
      items.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 2) el.classList.add("is-visible");
      });
    }, 1200);
  }

  /* -------------------------------------------------------------- header */

  function initHeader() {
    var header = $("[data-header]");
    if (header) {
      var onScroll = function () {
        var on = window.scrollY > 8;
        header.classList.toggle("border-brand-900/[.08]", on);
        header.classList.toggle("shadow-soft", on);
        header.classList.toggle("border-transparent", !on);
      };
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
    }

    /* meniu mobil */
    var menu = $("[data-mobile-menu]");
    if (menu) {
      var panel = $("[data-menu-panel]", menu);
      var overlay = $("[data-menu-overlay]", menu);
      var trigger = $("[data-menu-open]");

      var openMenu = function () {
        menu.classList.remove("pointer-events-none");
        menu.setAttribute("aria-hidden", "false");
        overlay.classList.replace("opacity-0", "opacity-100");
        panel.classList.replace("-translate-x-full", "translate-x-0");
        if (trigger) trigger.setAttribute("aria-expanded", "true");
        scrollLock.on();
      };
      var closeMenu = function () {
        if (menu.classList.contains("pointer-events-none")) return;
        menu.classList.add("pointer-events-none");
        menu.setAttribute("aria-hidden", "true");
        overlay.classList.replace("opacity-100", "opacity-0");
        panel.classList.replace("translate-x-0", "-translate-x-full");
        if (trigger) trigger.setAttribute("aria-expanded", "false");
        scrollLock.off();
      };

      if (trigger) trigger.addEventListener("click", openMenu);
      $$("[data-menu-close]", menu).forEach(function (b) { b.addEventListener("click", closeMenu); });
      overlay.addEventListener("click", closeMenu);
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeMenu(); });
    }

    /* căutare */
    var toggle = $("[data-search-toggle]");
    var panelSearch = $("[data-search-panel]");
    if (toggle && panelSearch) {
      var input = $("[data-search-input]", panelSearch);
      var results = $("[data-search-results]", panelSearch);
      var iconClosed = $("[data-search-icon='closed']");
      var iconOpen = $("[data-search-icon='open']");
      var open = false;

      var setSearch = function (state) {
        open = state;
        panelSearch.classList.toggle("invisible", !state);
        panelSearch.classList.toggle("opacity-0", !state);
        panelSearch.classList.toggle("scale-y-95", !state);
        panelSearch.classList.toggle("opacity-100", state);
        panelSearch.classList.toggle("scale-y-100", state);
        toggle.setAttribute("aria-expanded", String(state));
        if (iconClosed) iconClosed.classList.toggle("hidden", state);
        if (iconOpen) iconOpen.classList.toggle("hidden", !state);
        if (state) {
          setTimeout(function () { input && input.focus(); }, 120);
        } else if (results) {
          results.classList.add("hidden");
          results.innerHTML = "";
          if (input) input.value = "";
        }
      };

      toggle.addEventListener("click", function () { setSearch(!open); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && open) setSearch(false); });

      if (input && results && CFG.routes) {
        var run = debounce(function () {
          var q = input.value.trim();
          if (q.length < 2) {
            results.classList.add("hidden");
            results.innerHTML = "";
            return;
          }
          var url = CFG.routes.predictive_search + "?q=" + encodeURIComponent(q) +
            "&resources[type]=product&resources[limit]=5&section_id=predictive-search";
          fetch(url)
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, "text/html");
              var inner = doc.querySelector("#shopify-section-predictive-search") || doc.body;
              results.innerHTML = inner.innerHTML.trim();
              results.classList.toggle("hidden", results.innerHTML === "");
            })
            .catch(function () { results.classList.add("hidden"); });
        }, 250);
        input.addEventListener("input", run);
      }
    }
  }

  /* --------------------------------------------------------- bara de sus */

  function initAnnouncement() {
    var bar = $("[data-announcement]");
    if (!bar) return;
    var items = $$("[data-announcement-item]", bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.add("hidden");
      i = (i + 1) % items.length;
      items[i].classList.remove("hidden");
      items[i].classList.remove("animate-fade-up");
      void items[i].offsetWidth;
      items[i].classList.add("animate-fade-up");
    }, 4500);
  }

  function initPromo() {
    var promo = $("[data-promo-banner]");
    if (!promo) return;
    var key = "blemore-promo-" + (promo.getAttribute("data-promo-key") || "1");
    try {
      if (localStorage.getItem(key) === "dismissed") return;
    } catch (e) { /* stocare indisponibilă */ }
    promo.hidden = false;
    var close = $("[data-promo-close]", promo);
    if (close) {
      close.addEventListener("click", function () {
        promo.hidden = true;
        try { localStorage.setItem(key, "dismissed"); } catch (e) { /* ignorăm */ }
      });
    }
  }

  /* ------------------------------------------------------------ carusele */

  function initScrollers() {
    $$("[data-scroller]").forEach(function (root) {
      var track = $("[data-scroller-track]", root);
      var prev = $("[data-scroller-prev]", root);
      var next = $("[data-scroller-next]", root);
      if (!track) return;

      var progress = $("[data-scroller-progress]", root);

      var update = function () {
        if (prev) prev.disabled = track.scrollLeft <= 8;
        if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 8;

        if (progress) {
          var max = track.scrollWidth - track.clientWidth;
          var ratio = track.clientWidth / track.scrollWidth;
          var pct = Math.min(1, Math.max(0.12, ratio));
          progress.style.width = (pct * 100).toFixed(1) + "%";
          progress.style.marginLeft = max > 0
            ? ((track.scrollLeft / max) * (100 - pct * 100)).toFixed(1) + "%"
            : "0%";
        }
      };
      /* avansăm cu numărul întreg de carduri care încap, ca să nu rămână
         un card tăiat la jumătate după apăsare */
      var go = function (dir) {
        var first = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || "0") || 0;
        var step = first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.85;
        var perView = Math.max(1, Math.floor((track.clientWidth + gap) / step));
        track.scrollBy({ left: dir * step * perView, behavior: "smooth" });
      };
      if (prev) prev.addEventListener("click", function () { go(-1); });
      if (next) next.addEventListener("click", function () { go(1); });
      track.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();
    });
  }

  function initHero() {
    var hero = $("[data-hero]");
    if (!hero) return;
    var slides = $$("[data-hero-slide]", hero);
    if (!slides.length) return;
    var dots = $$("[data-hero-dot]", hero);
    var active = 0;
    var timer = null;
    var fallback = null;
    var delay = parseInt(hero.getAttribute("data-autoplay") || "0", 10);
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function render() {
      slides.forEach(function (slide, i) {
        var offset = i - active;
        var half = slides.length / 2;
        if (offset > half) offset -= slides.length;
        if (offset < -half) offset += slides.length;
        var isActive = offset === 0;
        var isSide = Math.abs(offset) === 1;

        slide.style.transform = "translateX(calc(-50% + " + offset * 82 + "%)) scale(" + (isActive ? 1 : 0.82) + ")";
        slide.style.filter = isActive ? "none" : "blur(5px)";
        slide.style.pointerEvents = isActive ? "auto" : "none";
        slide.setAttribute("aria-hidden", String(!isActive));

        slide.classList.toggle("z-20", isActive);
        slide.classList.toggle("opacity-100", isActive);
        slide.classList.toggle("z-10", !isActive && isSide);
        slide.classList.toggle("opacity-60", !isActive && isSide);
        slide.classList.toggle("hidden", !isActive && isSide);
        slide.classList.toggle("lg:block", !isActive && isSide);
        slide.classList.toggle("opacity-0", !isActive && !isSide);
        slide.classList.toggle("z-0", !isActive && !isSide);

        /* videoclipul rulează doar pe slide-ul activ, de la început */
        var vid = slide.querySelector("[data-hero-video]");
        if (vid) {
          vid.muted = true;
          if (isActive && !reduceMotion) {
            try { vid.currentTime = 0; } catch (e) { /* metadatele nu s-au încărcat încă */ }
            var p = vid.play();
            if (p && p.catch) p.catch(function () { /* redare blocată de browser */ });
          } else {
            vid.pause();
          }
        }

        if (isActive) {
          var content = $("[data-hero-content]", slide);
          if (content) {
            content.classList.remove("animate-fade-up");
            void content.offsetWidth;
            content.classList.add("animate-fade-up");
          }
        }
      });

      dots.forEach(function (dot, i) {
        var on = i === active;
        dot.classList.toggle("w-8", on);
        dot.classList.toggle("bg-brand-700", on);
        dot.classList.toggle("w-2", !on);
        dot.classList.toggle("bg-brand-300", !on);
        dot.setAttribute("aria-current", String(on));
      });
    }

    function go(dir) {
      active = (active + dir + slides.length) % slides.length;
      render();
      start();
    }
    function activeVideo() {
      return slides[active] ? slides[active].querySelector("[data-hero-video]") : null;
    }

    function start() {
      stop();
      if (delay <= 0 || slides.length < 2) return;
      /* Pe un slide cu video nu pornim cronometrul. Trecem mai departe abia
         când clipul s-a terminat, ca să nu fie tăiat la jumătate. */
      var v = activeVideo();
      if (v && !reduceMotion) {
        /* dacă browserul blochează redarea, nu rămânem blocați pe slide */
        clearTimeout(fallback);
        fallback = setTimeout(function () {
          if (v.paused || v.currentTime === 0) {
            timer = setInterval(function () { go(1); }, delay);
          }
        }, 3000);
        return;
      }
      timer = setInterval(function () { go(1); }, delay);
    }
    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
      clearTimeout(fallback);
    }

    /* la finalul clipului mergem la slide-ul următor, sau îl reluăm dacă rotirea e oprită */
    slides.forEach(function (slide, i) {
      var v = slide.querySelector("[data-hero-video]");
      if (!v) return;
      v.addEventListener("ended", function () {
        if (i !== active) return;
        if (delay > 0 && slides.length > 1) {
          go(1);
          start();
        } else {
          v.currentTime = 0;
          v.play().catch(function () { /* redare blocată */ });
        }
      });
    });

    var prev = $("[data-hero-prev]", hero);
    var next = $("[data-hero-next]", hero);
    if (prev) prev.addEventListener("click", function () { go(-1); start(); });
    if (next) next.addEventListener("click", function () { go(1); start(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () { active = i; render(); start(); });
    });

    hero.addEventListener("mouseenter", stop);
    hero.addEventListener("mouseleave", start);

    /* Pe telefon nu exista hover. Fara asta, slide-ul se poate schimba exact in
       secunda in care cineva intinde degetul spre buton, iar apasarea ajunge pe
       alt slide. Orice atingere opreste rotirea, iar dupa cateva secunde de
       liniste porneste din nou. */
    var reluare;
    function amana() {
      stop();
      clearTimeout(reluare);
      reluare = setTimeout(start, 9000);
    }
    hero.addEventListener("pointerdown", amana, { passive: true });
    hero.addEventListener("focusin", stop);

    /* Tragere cu degetul: slide-ul urmărește degetul, iar schimbarea se face
       doar dacă gestul e clar orizontal, ca să nu fure derularea paginii. */
    var touchX = null, touchY = null, horizontal = null, dragging = false;

    function activeSlide() { return slides[active]; }

    hero.addEventListener("touchstart", function (e) {
      if (slides.length < 2) return;
      touchX = e.touches[0].clientX;
      touchY = e.touches[0].clientY;
      horizontal = null;
      dragging = true;
      stop();
    }, { passive: true });

    hero.addEventListener("touchmove", function (e) {
      if (!dragging || touchX === null) return;
      var dx = e.touches[0].clientX - touchX;
      var dy = e.touches[0].clientY - touchY;

      if (horizontal === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
        horizontal = Math.abs(dx) > Math.abs(dy);
      }
      if (!horizontal) return;

      var el = activeSlide();
      if (el) {
        el.style.transition = "none";
        el.style.transform = "translateX(calc(-50% + " + (dx * 0.35) + "px)) scale(1)";
      }
    }, { passive: true });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      var el = activeSlide();
      if (el) el.style.transition = "";

      var dx = touchX === null ? 0 : (e.changedTouches[0].clientX - touchX);
      var threshold = Math.max(36, hero.clientWidth * 0.08);

      touchX = null;
      touchY = null;

      if (horizontal && Math.abs(dx) > threshold) {
        go(dx < 0 ? 1 : -1);
      } else if (horizontal) {
        /* A tras putin dar nu destul, readucem slide-ul la locul lui. */
        render();
        start();
      } else {
        /* Atingere simpla, deci probabil un clic pe buton. Nu atingem nimic,
           orice reasezare s-ar vedea ca o tresarire chiar sub deget. */
        start();
      }
      horizontal = null;
    }

    hero.addEventListener("touchend", endDrag, { passive: true });
    hero.addEventListener("touchcancel", endDrag, { passive: true });

    render();
    start();
  }

  /* --------------------------------------------------- înainte și după */

  function initCompare() {
    $$("[data-compare]").forEach(function (frame) {
      var clip = $("[data-compare-clip]", frame);
      var handle = $("[data-compare-handle]", frame);
      if (!clip || !handle) return;
      var dragging = false;

      function setPos(clientX) {
        var rect = frame.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.min(96, Math.max(4, pct));
        clip.style.clipPath = "inset(0 " + (100 - pct) + "% 0 0)";
        handle.style.left = pct + "%";
        frame.setAttribute("aria-valuenow", String(Math.round(pct)));
      }

      frame.addEventListener("pointerdown", function (e) {
        dragging = true;
        frame.setPointerCapture(e.pointerId);
        setPos(e.clientX);
      });
      frame.addEventListener("pointermove", function (e) { if (dragging) setPos(e.clientX); });
      frame.addEventListener("pointerup", function () { dragging = false; });
      frame.addEventListener("keydown", function (e) {
        var now = parseInt(frame.getAttribute("aria-valuenow") || "50", 10);
        if (e.key === "ArrowLeft") { e.preventDefault(); setPosPercent(Math.max(4, now - 4)); }
        if (e.key === "ArrowRight") { e.preventDefault(); setPosPercent(Math.min(96, now + 4)); }
      });

      function setPosPercent(pct) {
        clip.style.clipPath = "inset(0 " + (100 - pct) + "% 0 0)";
        handle.style.left = pct + "%";
        frame.setAttribute("aria-valuenow", String(pct));
      }
    });
  }

  /* ---------------------------------------------------------------- coș */

  var cart = {
    open: function () {
      var drawer = $("[data-cart-drawer]");
      if (!drawer) return;
      drawer.classList.remove("pointer-events-none");
      drawer.setAttribute("aria-hidden", "false");
      $("[data-cart-overlay]", drawer).classList.replace("opacity-0", "opacity-100");
      $("[data-cart-panel]", drawer).classList.replace("translate-x-full", "translate-x-0");
      scrollLock.on();
    },
    close: function () {
      var drawer = $("[data-cart-drawer]");
      if (!drawer || drawer.classList.contains("pointer-events-none")) return;
      drawer.classList.add("pointer-events-none");
      drawer.setAttribute("aria-hidden", "true");
      $("[data-cart-overlay]", drawer).classList.replace("opacity-100", "opacity-0");
      $("[data-cart-panel]", drawer).classList.replace("translate-x-0", "translate-x-full");
      scrollLock.off();
    },
    /* Panoul se construiește din /cart.js, nu prin Section Rendering API.
       O secțiune inclusă în layout nu este adresabilă prin acel API, întoarce gol. */
    render: function (data) {
      var body = $("[data-cart-drawer-body]");
      if (!body) return;

      if (data.item_count === 0) {
        body.innerHTML =
          '<div class="flex min-h-0 flex-1 flex-col items-center justify-center gap-4 px-8 text-center">' +
            '<span class="grid h-16 w-16 place-items-center rounded-full bg-gold-200/60 text-brand-700">' +
              '<svg class="h-7 w-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
            "</span>" +
            '<div><p class="font-display text-xl text-brand-950">Coșul tău este gol</p>' +
            '<p class="mt-1 text-sm text-ink-muted">Descoperă ritualurile Blemoré și alege produsele potrivite tenului tău.</p></div>' +
            '<a href="/collections/all" class="btn-primary btn-md mt-1">Descoperă produsele</a>' +
          "</div>";
        return;
      }

      var threshold = CFG.freeShippingThreshold || 0;
      var remaining = threshold - data.total_price;
      var progress = threshold > 0 ? Math.min(100, (data.total_price / threshold) * 100) : 0;

      var bar = "";
      if (threshold > 0) {
        bar =
          '<div class="px-5 pt-4"><div class="rounded-2xl border border-brand-900/[.07] bg-white px-4 py-3">' +
            '<div class="flex items-center gap-2 text-[13px] font-medium text-ink-soft">' +
              '<svg class="h-4 w-4 shrink-0 text-brand-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>' +
              (remaining <= 0
                ? '<span class="font-semibold text-brand-800">Ai livrare gratuită la această comandă</span>'
                : "<span>Mai adaugă <strong class=\"whitespace-nowrap text-brand-800\">" + money(remaining) + "</strong> pentru livrare gratuită</span>") +
            "</div>" +
            '<div class="mt-2.5 h-1.5 overflow-hidden rounded-full bg-brand-100">' +
              '<div class="h-full rounded-full bg-gradient-to-r from-gold-500 to-gold-400 transition-all duration-500 ease-smooth" style="width:' + progress + '%"></div>' +
            "</div>" +
          "</div></div>";
      }

      var items = data.items.map(function (item, i) {
        var line = i + 1;
        var variant = item.variant_title && item.variant_title !== "Default Title"
          ? '<p class="mt-0.5 text-xs text-ink-muted">' + esc(item.variant_title) + "</p>" : "";
        return (
          '<li class="flex gap-3.5 rounded-2xl border border-brand-900/[.06] bg-white p-3 shadow-soft">' +
            '<a href="' + esc(item.url) + '" class="relative h-[76px] w-[76px] shrink-0 overflow-hidden rounded-xl bg-cream-soft">' +
              (item.image ? '<img src="' + esc(thumb(item.image, 160)) + '" alt="" width="76" height="76" loading="lazy" class="h-full w-full object-cover">' : "") +
            "</a>" +
            '<div class="flex min-w-0 flex-1 flex-col">' +
              '<div class="flex items-start justify-between gap-2">' +
                '<a href="' + esc(item.url) + '" class="line-clamp-2 font-display text-[15px] leading-snug text-brand-950 transition-colors hover:text-brand-700">' + esc(item.product_title) + "</a>" +
                '<button type="button" data-cart-remove="' + line + '" aria-label="Elimină din coș" class="grid h-7 w-7 shrink-0 place-items-center rounded-full text-ink-muted transition-colors hover:bg-brand-50 hover:text-brand-800">' +
                  '<svg class="h-[15px] w-[15px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' +
                "</button>" +
              "</div>" + variant +
              '<div class="mt-auto flex items-center justify-between pt-2">' +
                '<div class="flex items-center rounded-full border border-brand-900/10 bg-cream">' +
                  '<button type="button" data-cart-qty="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Scade cantitatea" class="grid h-7 w-7 place-items-center rounded-full text-ink-soft transition-colors hover:text-brand-800">' +
                    '<svg class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>' +
                  "</button>" +
                  '<span class="w-6 text-center text-[13px] font-semibold text-brand-950">' + item.quantity + "</span>" +
                  '<button type="button" data-cart-qty="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Crește cantitatea" class="grid h-7 w-7 place-items-center rounded-full text-ink-soft transition-colors hover:text-brand-800">' +
                    '<svg class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/><path d="M12 5v14"/></svg>' +
                  "</button>" +
                "</div>" +
                '<span class="whitespace-nowrap text-sm font-bold text-brand-950">' + money(item.final_line_price) + "</span>" +
              "</div>" +
            "</div>" +
          "</li>"
        );
      }).join("");

      var footer =
        '<div class="border-t border-brand-900/[.07] bg-white/70 px-5 py-4 backdrop-blur">' +
          '<div class="flex items-center justify-between text-[15px]">' +
            '<span class="font-medium text-ink-soft">Subtotal</span>' +
            '<span class="whitespace-nowrap font-display text-xl text-brand-950">' + money(data.total_price) + "</span>" +
          "</div>" +
          '<p class="mt-1 text-xs text-ink-muted">' +
            (threshold > 0 && remaining <= 0
              ? "Livrarea este gratuită. Toate taxele sunt incluse în preț."
              : "Livrare prin curier rapid. Toate taxele sunt incluse în preț.") +
          "</p>" +
          '<form action="' + esc(CFG.routes.cart) + '" method="post" novalidate class="mt-3.5 grid gap-2.5">' +
            '<button type="submit" name="checkout" class="btn-primary btn-lg w-full">Finalizează comanda</button>' +
            '<a href="' + esc(CFG.routes.cart) + '" class="btn-outline btn-md w-full">Vezi coșul complet</a>' +
          "</form>" +
        "</div>";

      body.innerHTML = bar + '<ul class="min-h-0 flex-1 space-y-4 overflow-y-auto px-5 py-4">' + items + "</ul>" + footer;
    },
    counts: function (data) {
      var bubble = $("[data-cart-count]");
      if (bubble) {
        bubble.textContent = data.item_count;
        bubble.classList.toggle("hidden", data.item_count === 0);
        if (data.item_count > 0) {
          bubble.classList.remove("animate-pop");
          void bubble.offsetWidth;
          bubble.classList.add("animate-pop");
        }
      }
      var label = $("[data-cart-drawer-count]");
      if (label) {
        label.textContent = data.item_count > 0
          ? data.item_count + (data.item_count === 1 ? " produs" : " produse")
          : "";
      }
    },
    /* Schelet afișat cât timp așteptăm răspunsul, ca panoul să se deschidă instant */
    loading: function () {
      var body = $("[data-cart-drawer-body]");
      if (!body) return;
      var row = '<li class="flex gap-3.5 rounded-2xl border border-brand-900/[.06] bg-white p-3">' +
        '<span class="skeleton h-[76px] w-[76px] shrink-0 rounded-xl"></span>' +
        '<span class="flex flex-1 flex-col justify-center gap-2">' +
          '<span class="skeleton h-3.5 w-4/5 rounded-full"></span>' +
          '<span class="skeleton h-3 w-2/5 rounded-full"></span>' +
        "</span></li>";
      body.innerHTML = '<ul class="min-h-0 flex-1 space-y-4 overflow-y-auto px-5 py-4">' + row + "</ul>";
    },
    apply: function (data) {
      cart.render(data);
      cart.counts(data);
      cart.campaignBar(data);
      return data;
    },
    /* Bara de campanie: numărătoare cât timp coșul e gol, sumar + finalizare de îndată ce are ceva */
    campaignBar: function (data) {
      var bar = $("[data-campaign-bar]");
      if (!bar) return;
      var idle = $("[data-bar-idle]", bar);
      var box = $("[data-bar-cart]", bar);
      if (!idle || !box) return;

      var has = !!(data && data.item_count > 0);
      idle.classList.toggle("hidden", has);
      idle.classList.toggle("flex", !has);
      box.classList.toggle("hidden", !has);
      box.classList.toggle("flex", has);
      if (!has) return;

      var sum = $("[data-bar-cart-summary]", box);
      if (sum) {
        sum.textContent = data.item_count +
          (data.item_count === 1 ? " produs" : " produse") + " \u00b7 " + money(data.total_price);
      }
      var note = $("[data-bar-cart-note]", box);
      if (note) {
        var threshold = CFG.freeShippingThreshold || 0;
        if (threshold > 0) {
          var rest = threshold - data.total_price;
          note.textContent = rest <= 0
            ? "Livrare gratuită inclusă"
            : "Mai adaugă " + money(rest) + " pentru livrare gratuită";
        } else {
          note.textContent = "";
        }
      }
    },
    refresh: function () {
      return fetch(CFG.routes.cart + ".js", { cache: "no-store" })
        .then(function (r) { return r.json(); })
        .then(cart.apply)
        .catch(function () { /* rețea indisponibilă */ });
    },
    add: function (id, quantity) {
      /* panoul se deschide imediat, fără să aștepte rețeaua */
      if (CFG.cartType !== "page") {
        cart.loading();
        cart.open();
      }
      return fetch(CFG.routes.cart_add, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || CFG.strings.error); });
          return r.json();
        })
        .then(function () {
          return fetch(CFG.routes.cart + ".js", { cache: "no-store" }).then(function (r) { return r.json(); });
        })
        .then(function (data) {
          cart.apply(data);
          if (CFG.cartType === "page") window.location.href = CFG.routes.cart;
        })
        .catch(function (err) {
          cart.refresh();
          throw err;
        });
    },
    /* Un singur drum la server. change.js întoarce coșul complet, nu mai cerem /cart.js */
    change: function (line, quantity) {
      return fetch(CFG.routes.cart_change, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data || !data.items) return cart.refresh();
          cart.counts(data);
          if (onCartPage()) {
            if (data.item_count === 0 || quantity === 0) {
              window.location.reload();
              return data;
            }
            renderCartPage(data);
            return data;
          }
          cart.render(data);
          return data;
        });
    }
  };

  var qtyQueue = {};
  var qtyTimers = {};

  function onCartPage() {
    return window.location.pathname.replace(/\/$/, "") === CFG.routes.cart.replace(/\/$/, "");
  }

  /* Actualizează pagina coșului pe loc, fără reîncărcare */
  function renderCartPage(data) {
    data.items.forEach(function (item, i) {
      var line = i + 1;
      var minus = $('[data-cart-qty="' + line + '"][data-qty]');
      var row = minus ? minus.closest("li") : null;
      if (!row) return;
      var display = row.querySelector("[data-qty-display]") || minus.parentElement.querySelector("span");
      if (display) display.textContent = item.quantity;
      $$('[data-cart-qty="' + line + '"]', row).forEach(function (b, k) {
        b.setAttribute("data-qty", String(k === 0 ? item.quantity - 1 : item.quantity + 1));
      });
      var price = row.querySelector("[data-line-price]");
      if (price) price.textContent = money(item.final_line_price);
    });

    var subtotal = $("[data-cart-subtotal]");
    if (subtotal) subtotal.textContent = money(data.total_price);
    var total = $("[data-cart-total]");
    if (total) total.textContent = money(data.total_price);

    var threshold = CFG.freeShippingThreshold || 0;
    if (threshold > 0) {
      var remaining = threshold - data.total_price;
      var bar = $("[data-free-bar]");
      if (bar) bar.style.width = Math.min(100, (data.total_price / threshold) * 100) + "%";
      var msg = $("[data-free-msg]");
      if (msg) {
        msg.innerHTML = remaining <= 0
          ? '<span class="font-semibold text-brand-800">Ai livrare gratuită la această comandă</span>'
          : "Mai adaugă <strong class=\"whitespace-nowrap text-brand-800\">" + money(remaining) + "</strong> pentru livrare gratuită";
      }
    }
  }

  function initCart() {
    var drawer = $("[data-cart-drawer]");
    if (drawer) {
      $("[data-cart-overlay]", drawer).addEventListener("click", cart.close);
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") cart.close(); });
      drawer.addEventListener("click", function (e) {
        var closeBtn = e.target.closest("[data-cart-close]");
        if (closeBtn) cart.close();
      });
    }

    var openLink = $("[data-cart-open]");
    if (openLink && CFG.cartType !== "page") {
      openLink.addEventListener("click", function (e) {
        e.preventDefault();
        cart.open();
      });
    }

    /* delegare pentru butoanele generate dinamic */
    document.addEventListener("click", function (e) {
      var quick = e.target.closest("[data-quick-add]");
      if (quick) {
        e.preventDefault();
        e.stopPropagation();
        var id = quick.getAttribute("data-quick-add");
        quick.disabled = true;
        cart.add(id, 1)
          .catch(function (err) { toast(err.message || CFG.strings.error); })
          .finally(function () { quick.disabled = false; });
        return;
      }

      var qtyBtn = e.target.closest("[data-cart-qty]");
      if (qtyBtn) {
        e.preventDefault();
        var line = parseInt(qtyBtn.getAttribute("data-cart-qty"), 10);
        var target = parseInt(qtyBtn.getAttribute("data-qty"), 10);
        if (target < 0) return;

        /* numărul se schimbă instant, cererea pleacă după ce te oprești din apăsat */
        var group = qtyBtn.parentElement;
        var display = group ? group.querySelector("span") : null;
        if (display) display.textContent = target;
        $$("[data-cart-qty]", group || document).forEach(function (b, k) {
          b.setAttribute("data-qty", String(k === 0 ? target - 1 : target + 1));
        });

        qtyQueue[line] = target;
        clearTimeout(qtyTimers[line]);
        qtyTimers[line] = setTimeout(function () {
          var q = qtyQueue[line];
          delete qtyQueue[line];
          cart.change(line, q).catch(function () { cart.refresh(); });
        }, 280);
        return;
      }

      var removeBtn = e.target.closest("[data-cart-remove]");
      if (removeBtn) {
        e.preventDefault();
        cart.change(parseInt(removeBtn.getAttribute("data-cart-remove"), 10), 0);
      }
    });

    /* mențiuni la comandă */
    document.addEventListener("change", function (e) {
      var note = e.target.closest("[data-cart-note]");
      if (!note) return;
      fetch(CFG.routes.cart_update, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: note.value })
      }).catch(function () { /* ignorăm */ });
    });
  }

  /* ------------------------------------------------------ pagina produs */

  function initProduct() {
    var root = $("[data-product-root]");
    if (!root) return;

    /* galerie */
    var gallery = $("[data-gallery]", root);
    if (gallery) {
      var images = $$("[data-gallery-image]", gallery);
      var thumbs = $$("[data-gallery-thumb]", root);
      var idx = 0;
      var show = function (i) {
        if (!images.length) return;
        idx = (i + images.length) % images.length;
        images.forEach(function (img, k) { img.classList.toggle("opacity-0", k !== idx); });
        thumbs.forEach(function (t, k) {
          var on = k === idx;
          t.classList.toggle("border-gold-500", on);
          t.classList.toggle("shadow-soft", on);
          t.classList.toggle("border-transparent", !on);
          t.classList.toggle("opacity-70", !on);
          t.setAttribute("aria-current", String(on));
        });
      };
      thumbs.forEach(function (t, k) { t.addEventListener("click", function () { show(k); }); });
      var gp = $("[data-gallery-prev]", gallery);
      var gn = $("[data-gallery-next]", gallery);
      if (gp) gp.addEventListener("click", function () { show(idx - 1); });
      if (gn) gn.addEventListener("click", function () { show(idx + 1); });
    }

    /* cantitate */
    var qtyInput = $("[data-qty-input]", root);
    var minus = $("[data-qty-minus]", root);
    var plus = $("[data-qty-plus]", root);
    if (qtyInput) {
      if (minus) minus.addEventListener("click", function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || "1", 10) - 1);
      });
      if (plus) plus.addEventListener("click", function () {
        qtyInput.value = Math.min(10, parseInt(qtyInput.value || "1", 10) + 1);
      });
    }

    /* variante */
    var dataEl = $("[data-variants]", root);
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : "[]"); } catch (e) { variants = []; }

    var idField = $("[data-variant-id]", root);
    var addBtn = $("[data-add-to-cart]", root);
    var addLabel = $("[data-add-label]", root);
    var priceBlock = $("[data-price-block]", root);
    var selected = [];

    $$("[data-option-value]", root).forEach(function (btn) {
      var pos = parseInt(btn.getAttribute("data-option-position"), 10) - 1;
      if (btn.getAttribute("aria-pressed") === "true") selected[pos] = btn.getAttribute("data-value");

      btn.addEventListener("click", function () {
        if (btn.disabled) return;
        var group = btn.parentElement;
        $$("[data-option-value]", group).forEach(function (other) {
          other.setAttribute("aria-pressed", "false");
          other.classList.remove("border-brand-700", "bg-brand-700", "text-cream", "shadow-soft");
          if (!other.disabled) other.classList.add("border-brand-900/15", "bg-white", "text-ink-soft");
        });
        btn.setAttribute("aria-pressed", "true");
        btn.classList.remove("border-brand-900/15", "bg-white", "text-ink-soft");
        btn.classList.add("border-brand-700", "bg-brand-700", "text-cream", "shadow-soft");
        selected[pos] = btn.getAttribute("data-value");
        syncVariant();
      });
    });

    function money(cents) {
      var value = (cents / 100).toLocaleString("ro-RO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var format = CFG.moneyFormat || "{{amount_with_comma_separator}} lei";
      return format.replace(/\{\{\s*\w+\s*\}\}/, value);
    }

    function syncVariant() {
      var match = variants.find(function (v) {
        return selected.every(function (val, i) { return !val || v.options[i] === val; });
      });
      if (!match) return;

      if (idField) idField.value = match.id;
      if (addBtn) addBtn.disabled = !match.available;
      if (addLabel) addLabel.textContent = match.available ? "Adaugă în coș" : CFG.strings.soldOut;

      if (priceBlock) {
        var parts = '<span class="whitespace-nowrap font-bold text-brand-950 text-3xl">' + money(match.price) + "</span>";
        if (match.compare_at_price && match.compare_at_price > match.price) {
          parts += '<span class="whitespace-nowrap font-medium text-ink-muted line-through text-base">' + money(match.compare_at_price) + "</span>";
        }
        priceBlock.innerHTML = '<span class="inline-flex flex-wrap items-baseline gap-x-2">' + parts + "</span>";
      }
    }

    /* trimitere formular */
    var form = $("[data-product-form]", root);
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var id = idField ? idField.value : null;
        var qty = qtyInput ? parseInt(qtyInput.value || "1", 10) : 1;
        if (!id) return;
        if (addBtn) addBtn.disabled = true;
        cart.add(id, qty)
          .catch(function (err) { toast(err.message || CFG.strings.error); })
          .finally(function () { if (addBtn) addBtn.disabled = false; });
      });
    }
  }

  /* ------------------------------------------------------ clipuri video */

  function initReels() {
    var players = [];

    /* redare în card, pe prima pagină */
    $$("[data-reel-inline]").forEach(function (card) {
      var video = $("[data-reel-video]", card);
      var cover = $("[data-reel-cover]", card);
      var mute = $("[data-reel-mute]", card);
      var progress = $("[data-reel-progress]", card);
      if (!video) return;
      video.playsInline = true;
      players.push(video);

      var toggle = function () {
        if (video.paused) {
          players.forEach(function (other) { if (other !== video) other.pause(); });
          cover.classList.add("hidden");
          if (mute) mute.classList.replace("hidden", "grid");
          if (progress) progress.classList.remove("hidden");
          video.play().catch(function () { /* redare blocată */ });
        } else {
          video.pause();
        }
      };

      card.addEventListener("click", function (e) {
        if (e.target.closest("[data-reel-mute]")) return;
        toggle();
      });
      card.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggle(); }
      });

      if (mute) {
        mute.addEventListener("click", function (e) {
          e.stopPropagation();
          video.muted = !video.muted;
          $("[data-mute-on]", mute).classList.toggle("hidden", video.muted);
          $("[data-mute-off]", mute).classList.toggle("hidden", !video.muted);
          mute.setAttribute("aria-label", video.muted ? "Pornește sunetul" : "Oprește sunetul");
        });
      }

      video.addEventListener("timeupdate", function () {
        if (progress && video.duration) {
          progress.firstElementChild.style.width = (video.currentTime / video.duration) * 100 + "%";
        }
      });
      video.addEventListener("ended", function () {
        cover.classList.remove("hidden");
        if (progress) progress.firstElementChild.style.width = "0%";
      });

      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { if (!entry.isIntersecting && !video.paused) video.pause(); });
        }, { threshold: 0.35 }).observe(video);
      }
    });

    /* player pe tot ecranul, pornit din banda de pe pagina de produs */
    var modal = $("[data-reel-modal]");
    if (!modal) return;
    var list = $$("[data-reel]");
    if (!list.length) return;

    var video = $("[data-reel-modal-video]", modal);
    var playIcon = $("[data-reel-modal-play]", modal);
    var progress = $("[data-reel-modal-progress]", modal);
    var counter = $("[data-reel-modal-counter]", modal);
    var mute = $("[data-reel-modal-mute]", modal);
    var index = 0;
    video.playsInline = true;

    function load(i) {
      index = (i + list.length) % list.length;
      var btn = list[index];
      video.src = btn.getAttribute("data-reel-src");
      video.poster = btn.getAttribute("data-reel-poster");
      if (progress) progress.style.width = "0%";
      if (counter) counter.textContent = index + 1 + " / " + list.length;
      video.play().catch(function () { /* redare blocată */ });
    }

    function open(i) {
      modal.classList.remove("pointer-events-none", "opacity-0");
      modal.setAttribute("aria-hidden", "false");
      scrollLock.on();
      load(i);
    }
    function close() {
      modal.classList.add("pointer-events-none", "opacity-0");
      modal.setAttribute("aria-hidden", "true");
      video.pause();
      video.removeAttribute("src");
      video.load();
      scrollLock.off();
    }

    list.forEach(function (btn, i) {
      btn.addEventListener("click", function () { open(i); });
    });

    $$("[data-reel-modal-close]", modal).forEach(function (b) { b.addEventListener("click", close); });
    $("[data-reel-modal-overlay]", modal).addEventListener("click", close);
    $$("[data-reel-modal-prev]", modal).forEach(function (b) {
      b.addEventListener("click", function () { load(index - 1); });
    });
    $$("[data-reel-modal-next]", modal).forEach(function (b) {
      b.addEventListener("click", function () { load(index + 1); });
    });

    var stage = $("[data-reel-modal-stage]", modal);
    if (stage) {
      stage.addEventListener("click", function (e) {
        if (e.target.closest("[data-reel-modal-mute]")) return;
        if (video.paused) video.play().catch(function () { /* blocat */ });
        else video.pause();
      });
    }

    if (mute) {
      mute.addEventListener("click", function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        $("[data-mute-on]", mute).classList.toggle("hidden", video.muted);
        $("[data-mute-off]", mute).classList.toggle("hidden", !video.muted);
      });
    }

    video.addEventListener("play", function () { if (playIcon) playIcon.classList.replace("grid", "hidden"); });
    video.addEventListener("pause", function () { if (playIcon) playIcon.classList.replace("hidden", "grid"); });
    video.addEventListener("timeupdate", function () {
      if (progress && video.duration) progress.style.width = (video.currentTime / video.duration) * 100 + "%";
    });
    video.addEventListener("ended", function () { load(index + 1); });

    document.addEventListener("keydown", function (e) {
      if (modal.getAttribute("aria-hidden") === "true") return;
      if (e.key === "Escape") close();
      if (e.key === "ArrowRight") load(index + 1);
      if (e.key === "ArrowLeft") load(index - 1);
    });
  }

  /* -------------------------------------------------- numărătoare inversă */

  function initCountdowns() {
    var boxes = $$("[data-countdown]");
    if (!boxes.length) return;

    boxes.forEach(function (box) {
      /* „2026-08-12 23:59" citit ca oră locală, nu UTC */
      var raw = (box.getAttribute("data-deadline") || "").trim().replace(" ", "T");
      if (raw.length === 16) raw += ":00";
      var end = new Date(raw).getTime();
      if (isNaN(end)) {
        box.style.display = "none";
        return;
      }

      var cells = {
        days: $('[data-cd="days"]', box),
        hours: $('[data-cd="hours"]', box),
        minutes: $('[data-cd="minutes"]', box),
        seconds: $('[data-cd="seconds"]', box)
      };
      var over = box.nextElementSibling && box.nextElementSibling.hasAttribute("data-countdown-over")
        ? box.nextElementSibling : null;

      function pad(n) { return n < 10 ? "0" + n : String(n); }

      function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          clearInterval(timer);
          /* Campania trece din „începe în" în „se încheie în". Starea o decide
             serverul, deci reîncărcăm o singură dată ca să o primim actualizată. */
          if (box.hasAttribute("data-countdown-reload") && !window.__cdReloaded) {
            window.__cdReloaded = true;
            window.location.reload();
            return;
          }
          box.classList.add("hidden");
          if (over) over.classList.remove("hidden");
          return;
        }
        var s = Math.floor(left / 1000);
        if (cells.days) cells.days.textContent = pad(Math.floor(s / 86400));
        if (cells.hours) cells.hours.textContent = pad(Math.floor((s % 86400) / 3600));
        if (cells.minutes) cells.minutes.textContent = pad(Math.floor((s % 3600) / 60));
        if (cells.seconds) cells.seconds.textContent = pad(s % 60);
      }

      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* Videoclipuri ambientale, pornesc doar când ajung pe ecran */
  function initInViewVideos() {
    var vids = $$("[data-inview-video]");
    if (!vids.length) return;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    vids.forEach(function (v) {
      v.muted = true;
      if (reduce) return;
      if (!("IntersectionObserver" in window)) {
        v.play().catch(function () { /* redare blocată */ });
        return;
      }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            v.play().catch(function () { /* redare blocată */ });
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.25 }).observe(v);
    });
  }

  /* Bara de campanie apare după ce antetul iese din ecran */
  function initCampaignBar() {
    var bar = $("[data-campaign-bar]");
    var hero = $("[data-campaign-hero]");
    if (!bar || !hero) return;

    /* Dacă antetul spune că există deja produse în coș, cerem starea reală o
       singură dată, ca bara să pornească direct pe varianta cu finalizare. */
    var bubble = $("[data-cart-count]");
    if (bubble && parseInt(bubble.textContent, 10) > 0) cart.refresh();

    function show(on) {
      bar.classList.toggle("translate-y-[150%]", !on);
      bar.classList.toggle("opacity-0", !on);
      bar.classList.toggle("pointer-events-none", !on);
      /* Butonul WhatsApp urcă, altfel bara i-ar trece peste el */
      document.body.classList.toggle("bara-jos", on);
    }

    /* Apăsarea pe sumar deschide sertarul, ca să vezi ce ai înainte de finalizare */
    var openBtn = $("[data-bar-open-cart]", bar);
    if (openBtn) {
      openBtn.addEventListener("click", function (e) {
        e.preventDefault();
        cart.open();
      });
    }

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        show(!entries[0].isIntersecting);
      }, { threshold: 0.08 }).observe(hero);
    } else {
      window.addEventListener("scroll", function () {
        show(window.scrollY > hero.offsetHeight * 0.8);
      }, { passive: true });
    }
  }

  /* ----------------------------------------------------------- cookie-uri */

  function initCookieConsent() {
    var root = $("[data-cookie-root]");
    if (!root) return;

    var card = $("[data-cookie-card]", root);
    var prefs = $("[data-cookie-prefs]", root);
    var saveBtn = $("[data-cookie-save]", root);
    var toggleBtn = $("[data-cookie-toggle]", root);
    var boxes = {
      analytics: $("[data-cookie-analytics]", root),
      marketing: $("[data-cookie-marketing]", root),
      preferences: $("[data-cookie-preferences]", root)
    };

    function open() {
      root.hidden = false;
      document.body.classList.add("cookie-deschis");
      requestAnimationFrame(function () {
        root.classList.remove("opacity-0");
        card.classList.remove("translate-y-4");
      });
    }

    function close() {
      root.classList.add("opacity-0");
      card.classList.add("translate-y-4");
      document.body.classList.remove("cookie-deschis");
      setTimeout(function () { root.hidden = true; }, 450);
    }

    /* Shopify înregistrează consimțământul, dar shouldShowBanner() rămâne adevărat
       și după acceptare, deci bannerul reapărea la fiecare pagină. Ținem noi minte
       că vizitatorul a decis. */
    var CHEIE = "blemore:consent:v1";

    function amDecis() {
      try { return !!localStorage.getItem(CHEIE); } catch (e) { return false; }
    }

    function tineMinte(consent) {
      try { localStorage.setItem(CHEIE, JSON.stringify(consent)); } catch (e) { /* stocare blocată */ }
    }

    function save(consent) {
      tineMinte(consent);
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.setTrackingConsent === "function") {
        api.setTrackingConsent({
          analytics: !!consent.analytics,
          marketing: !!consent.marketing,
          preferences: !!consent.preferences,
          sale_of_data: !!consent.marketing
        }, close);
      } else {
        close();
      }
    }

    if (toggleBtn) {
      toggleBtn.addEventListener("click", function () {
        var deschis = !prefs.classList.contains("hidden");
        prefs.classList.toggle("hidden", deschis);
        prefs.classList.toggle("grid", !deschis);
        saveBtn.classList.toggle("hidden", deschis);
        saveBtn.classList.toggle("flex", !deschis);
        toggleBtn.textContent = deschis ? "Personalizează" : "Ascunde detaliile";
      });
    }

    $("[data-cookie-accept]", root).addEventListener("click", function () {
      save({ analytics: true, marketing: true, preferences: true });
    });
    $("[data-cookie-reject]", root).addEventListener("click", function () {
      save({ analytics: false, marketing: false, preferences: false });
    });
    if (saveBtn) {
      saveBtn.addEventListener("click", function () {
        save({
          analytics: boxes.analytics && boxes.analytics.checked,
          marketing: boxes.marketing && boxes.marketing.checked,
          preferences: boxes.preferences && boxes.preferences.checked
        });
      });
    }

    /* Linkul din subsol permite răzgândirea, cerință a legislației europene */
    document.addEventListener("click", function (e) {
      var link = e.target.closest("[data-cookie-settings]");
      if (!link) return;
      e.preventDefault();
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api) {
        boxes.analytics.checked = !!api.analyticsProcessingAllowed();
        boxes.marketing.checked = !!api.marketingAllowed();
        boxes.preferences.checked = !!api.preferencesProcessingAllowed();
      }
      prefs.classList.remove("hidden");
      prefs.classList.add("grid");
      saveBtn.classList.remove("hidden");
      saveBtn.classList.add("flex");
      toggleBtn.textContent = "Ascunde detaliile";
      open();
    });

    /* Decizia de afișare e a noastră, nu a Shopify. shouldShowBanner() întoarce
       fals de îndată ce merchantul opreste bannerul nativ din setări, iar atunci
       ar dispărea și al nostru. Ne uităm doar dacă vizitatorul a ales deja. */
    if (amDecis()) return;

    /* Încărcăm API-ul de consimțământ ca să putem scrie alegerea, dar bannerul
       apare oricum, chiar dacă API-ul nu răspunde. */
    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () {});
    }
    setTimeout(function () {
      if (!amDecis()) open();
    }, 900);
  }

  /* ------------------------------------------------------------- recenzii */

  function initReviews() {
    var root = $("[data-reviews]");
    if (!root) return;

    /* Formularul stă ascuns până îl cere cineva. Dacă tocmai s-a trimis, îl
       lăsăm deschis ca să se vadă confirmarea. */
    var form = $("[data-review-form]", root);
    if (form) {
      var trimis = !!$(".field, [id='form-recenzie']", form) && window.location.search.indexOf("contact_posted=true") !== -1;
      if (trimis) form.classList.remove("hidden");

      $$("[data-review-open]", root).forEach(function (btn) {
        btn.addEventListener("click", function () {
          form.classList.remove("hidden");
          form.scrollIntoView({ behavior: "smooth", block: "center" });
          var primul = $("input[name='contact[name]']", form);
          if (primul) setTimeout(function () { primul.focus(); }, 400);
        });
      });

      var anuleaza = $("[data-review-cancel]", form);
      if (anuleaza) {
        anuleaza.addEventListener("click", function () { form.classList.add("hidden"); });
      }
    }

    var carduri = $$("[data-review]", root);
    if (!carduri.length) return;

    var lista = $("[data-review-list]", root);
    var gol = $("[data-review-empty]", root);
    var maiMulte = $("[data-review-more]", root);
    var vizibileInitial = carduri.filter(function (c) { return !c.classList.contains("hidden"); }).length;
    var toateAfisate = vizibileInitial >= carduri.length;
    var filtruCurent = "toate";

    function seVede(card) {
      if (filtruCurent === "toate") return true;
      if (filtruCurent === "poze") return card.getAttribute("data-poze") === "true";
      return card.getAttribute("data-nota") === filtruCurent;
    }

    function aplica() {
      var aratate = 0;
      carduri.forEach(function (card) {
        var potrivit = seVede(card);
        /* Cât timp nu s-a apăsat „vezi toate", limităm doar lista nefiltrată. */
        var peste = !toateAfisate && filtruCurent === "toate" && aratate >= vizibileInitial;
        var afiseaza = potrivit && !peste;
        card.classList.toggle("hidden", !afiseaza);
        if (potrivit) aratate++;
      });
      if (gol) gol.classList.toggle("hidden", aratate > 0);
      if (maiMulte) {
        maiMulte.classList.toggle("hidden", toateAfisate || filtruCurent !== "toate");
      }
      if (lista) {
        /* Animația de intrare se reia, altfel cardurile nou apărute rămân șterse. */
        $$("[data-review]:not(.hidden)", lista).forEach(function (c) { c.classList.add("is-visible"); });
      }
    }

    $$("[data-review-filter]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        filtruCurent = btn.getAttribute("data-review-filter");
        $$("[data-review-filter]", root).forEach(function (alt) {
          var activ = alt === btn;
          alt.classList.toggle("border-brand-700", activ);
          alt.classList.toggle("bg-brand-700", activ);
          alt.classList.toggle("text-cream", activ);
          alt.classList.toggle("border-brand-900/15", !activ);
          alt.classList.toggle("bg-white", !activ);
          alt.classList.toggle("text-ink-soft", !activ);
        });
        aplica();
      });
    });

    if (maiMulte) {
      maiMulte.addEventListener("click", function () {
        toateAfisate = true;
        aplica();
        maiMulte.classList.add("hidden");
      });
    }
  }

  /* Mod de previzualizare pentru recenzii.
     Se pornește cu ?demo=recenzii în adresă, opțional &n=40 pentru câte.
     Generează totul în browser, nu scrie nimic în magazin, deci niciun client
     nu poate vedea vreodată datele astea. Serveste doar la verificat cum arată
     secțiunea plină, pe orice ecran. */
  function initReviewsDemo() {
    var CHEIE = "blemore:demo-recenzii";
    var p = new URLSearchParams(window.location.search);
    var cerut = p.get("demo");

    /* Odată pornit, rămâne pornit în browserul ăsta, ca să poți naviga pe
       linkuri normale. Se oprește cu ?demo=off sau din pastila din colț. */
    if (cerut === "off") {
      try { localStorage.removeItem(CHEIE); } catch (e) { /* stocare blocată */ }
      return;
    }

    var cate = parseInt(p.get("n"), 10);
    if (cerut === "recenzii") {
      if (!cate || cate < 1) cate = 34;
      try { localStorage.setItem(CHEIE, String(cate)); } catch (e) { /* stocare blocată */ }
    } else {
      var salvat = null;
      try { salvat = localStorage.getItem(CHEIE); } catch (e) { salvat = null; }
      if (!salvat) return;
      cate = parseInt(salvat, 10) || 34;
    }

    /* Stele și pe cardurile de produs, oriunde apar: colecție, carusele,
       produse similare. Altfel previzualizarea ar arăta recenzii doar în
       pagina produsului și ar părea că sincronizarea nu merge. */
    stelePeCarduri();

    var corp = $("[data-reviews-body]");
    if (!corp) return;

    var nume = ["Andreea M.", "Ioana D.", "Elena P.", "Cristina V.", "Raluca S.", "Maria T.",
      "Diana L.", "Alexandra B.", "Georgiana N.", "Roxana I.", "Bianca F.", "Larisa C."];
    var orase = ["Timisoara", "Cluj-Napoca", "Bucuresti", "Brasov", "Iasi", "Sibiu",
      "Oradea", "Constanta", "Craiova", "Arad"];
    var titluri = ["Exemplu de titlu scurt", "Exemplu de titlu ceva mai lung ca sa vad cum se rupe",
      "", "Exemplu titlu mediu", ""];
    var texte = [
      "Text de previzualizare scurt.",
      "Text de previzualizare de lungime medie, cat sa vezi cum arata un card umplut normal si cum se aliniaza cu vecinii lui din acelasi rand.",
      "Text de previzualizare lung, care ocupa mai multe randuri, ca sa vezi pana unde creste cardul si daca autorul ramane lipit jos indiferent cat scrie cineva. Adaug inca o propozitie ca sa depaseasca sigur trei randuri pe telefon.",
      "Text mediu, cu o singura propozitie ceva mai desfasurata decat prima."
    ];
    var luni = ["ian.", "feb.", "mar.", "apr.", "mai", "iun.", "iul.", "aug.", "sept.", "oct.", "nov.", "dec."];

    /* Generator determinist, ca reincarcarea sa arate acelasi lucru. */
    var samanta = 7;
    function rnd(max) {
      samanta = (samanta * 1103515245 + 12345) % 2147483648;
      return samanta % max;
    }

    var lista = [];
    for (var i = 0; i < cate; i++) {
      var nota = 5;
      var z = rnd(10);
      if (z < 1) nota = 3; else if (z < 4) nota = 4;
      var d = new Date(2026, rnd(8), 1 + rnd(27));
      lista.push({
        n: nota,
        t: titluri[rnd(titluri.length)],
        c: texte[rnd(texte.length)],
        a: nume[rnd(nume.length)],
        o: orase[rnd(orase.length)],
        data: d.getDate() + " " + luni[d.getMonth()] + " " + d.getFullYear(),
        v: rnd(10) > 3
      });
    }

    var total = lista.length;
    var suma = lista.reduce(function (s, r) { return s + r.n; }, 0);
    var medie = Math.round((suma / total) * 10) / 10;
    var pe = [0, 0, 0, 0, 0];
    lista.forEach(function (r) { pe[r.n - 1]++; });

    function stele(nota, px) {
      var out = "";
      for (var i = 1; i <= 5; i++) {
        out += '<svg viewBox="0 0 24 24" fill="currentColor" class="h-[' + px + 'px] w-[' + px +
          'px]' + (i > nota ? " text-brand-200" : "") + '" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
      }
      return out;
    }

    var bare = "";
    for (var s5 = 5; s5 >= 1; s5--) {
      var c = pe[s5 - 1];
      var proc = Math.round((c / total) * 100);
      bare += '<div class="flex items-center gap-2.5">' +
        '<span class="w-3 shrink-0 text-right text-[12px] font-semibold text-ink-soft">' + s5 + "</span>" +
        '<span class="shrink-0 text-gold-500">' + stele(1, 12).split("</svg>")[0] + "</svg>" + "</span>" +
        '<span class="h-1.5 flex-1 overflow-hidden rounded-full bg-brand-100"><span class="block h-full rounded-full bg-gold-500" style="width:' + proc + '%"></span></span>' +
        '<span class="w-6 shrink-0 text-[12px] tabular-nums text-ink-muted">' + c + "</span></div>";
    }

    var carduri = lista.map(function (r, i) {
      return '<article class="reveal is-visible flex flex-col rounded-2xl border border-brand-900/[.08] bg-white p-4 transition-all duration-300 ease-smooth hover:-translate-y-1 hover:shadow-card-hover sm:p-5' +
        (i >= 6 ? " hidden" : "") + '" data-review data-nota="' + r.n + '" data-poze="false">' +
        '<div class="flex items-center justify-between gap-3"><span class="flex items-center gap-0.5 text-gold-500">' + stele(r.n, 15) + "</span>" +
        '<span class="shrink-0 text-[11.5px] text-ink-muted">' + r.data + "</span></div>" +
        (r.t ? '<p class="mt-2.5 text-[14.5px] font-semibold leading-snug text-brand-950">' + r.t + "</p>" : "") +
        '<p class="mt-1.5 flex-1 text-pretty text-[13.5px] leading-relaxed text-ink-soft">' + r.c + "</p>" +
        '<div class="mt-4 flex items-center gap-2.5 border-t border-brand-900/[.07] pt-3.5">' +
        '<span class="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-brand-700 font-display text-[13px] text-cream">' + r.a.charAt(0) + "</span>" +
        '<span class="min-w-0"><span class="block truncate text-[13px] font-semibold text-brand-950">' + r.a + "</span>" +
        '<span class="block text-[11.5px] text-ink-muted">' + r.o + "</span></span>" +
        (r.v ? '<span class="ml-auto inline-flex shrink-0 items-center gap-1 rounded-md bg-gold-500/20 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-caps text-brand-800">Verificat</span>' : "") +
        "</div></article>";
    }).join("");

    var filtre = '<button type="button" data-review-filter="toate" class="chip shrink-0 border border-brand-700 bg-brand-700 px-4 py-2 text-[13px] text-cream transition-all duration-300">Toate (' + total + ")</button>";
    for (var f = 5; f >= 1; f--) {
      if (pe[f - 1] > 0) {
        filtre += '<button type="button" data-review-filter="' + f + '" class="chip shrink-0 border border-brand-900/15 bg-white px-4 py-2 text-[13px] text-ink-soft transition-all duration-300 hover:border-brand-700/50 hover:text-brand-800">' + f + " stele (" + pe[f - 1] + ")</button>";
      }
    }

    corp.innerHTML =
      '<div class="mt-9 grid gap-6 rounded-[1.75rem] border border-brand-900/[.08] bg-white p-5 shadow-card sm:mt-11 sm:p-7 lg:grid-cols-[auto_1fr_auto] lg:items-center lg:gap-10">' +
        '<div class="text-center lg:text-left"><p class="font-sans text-[3.25rem] font-bold leading-none text-brand-950">' + String(medie).replace(".", ",") + "</p>" +
        '<span class="mt-2 flex justify-center gap-0.5 text-gold-500 lg:justify-start">' + stele(Math.round(medie), 18) + "</span>" +
        '<p class="mt-2 text-[13px] font-medium text-ink-muted">' + total + " recenzii</p></div>" +
        '<div class="space-y-1.5">' + bare + "</div>" +
        '<div class="lg:shrink-0"><button type="button" class="btn-primary btn-md w-full justify-center lg:w-auto" data-review-open>Scrie o recenzie</button></div>' +
      "</div>" +
      '<div class="no-scrollbar -mx-4 mt-7 flex gap-2 overflow-x-auto px-4 sm:mx-0 sm:flex-wrap sm:px-0">' + filtre + "</div>" +
      '<div class="mt-6 grid gap-3.5 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3" data-review-list>' + carduri + "</div>" +
      '<p class="mt-6 hidden text-center text-[14px] text-ink-muted" data-review-empty>Nicio recenzie care sa corespunda filtrului ales.</p>' +
      '<div class="mt-7 text-center"><button type="button" class="btn-outline btn-md" data-review-more>Vezi toate recenziile</button></div>' +
      "";

    if (!$("[data-demo-pill]")) {
      var pastila = document.createElement("a");
      pastila.setAttribute("data-demo-pill", "");
      pastila.href = "?demo=off";
      pastila.className =
        "fixed bottom-3 left-3 z-[70] inline-flex items-center gap-2 rounded-full bg-brand-950/90 px-3.5 py-2 text-[11px] font-bold uppercase tracking-caps text-cream shadow-card backdrop-blur transition-colors hover:bg-brand-950";
      pastila.innerHTML = '<span class="h-1.5 w-1.5 rounded-full bg-sale-500"></span>Previzualizare recenzii, oprește';
      document.body.appendChild(pastila);
    }
  }

  /* Nota unui produs în previzualizare, derivată din adresa lui, ca să fie
     aceeași pe toate paginile și între reîncărcări. */
  function notaDemo(cheie) {
    var h = 0;
    for (var i = 0; i < cheie.length; i++) h = (h * 31 + cheie.charCodeAt(i)) % 100000;
    var note = [4.4, 4.6, 4.7, 4.8, 4.9, 5.0];
    return { nota: note[h % note.length], cate: 8 + (h % 47) };
  }

  function stelePeCarduri() {
    $$('a[href*="/products/"]').forEach(function (link) {
      var img = link.querySelector("img");
      if (!img) return;
      if (link.querySelector("[data-demo-stele]")) return;

      /* Legătura acoperă tot cardul și e statică. Chipul trebuie pus în cutia
         imaginii, care e cea poziționată. Dacă nu găsim una, o facem noi. */
      var cutie = img.parentElement;
      while (cutie && cutie !== link && getComputedStyle(cutie).position !== "relative") {
        cutie = cutie.parentElement;
      }
      if (!cutie || cutie === link) {
        cutie = img.parentElement;
        cutie.classList.add("relative");
      }

      var cale = (link.getAttribute("href") || "").split("?")[0];
      var d = notaDemo(cale);
      var pline = Math.round(d.nota);

      var stele = "";
      for (var i = 1; i <= 5; i++) {
        stele += '<svg viewBox="0 0 24 24" fill="currentColor" class="h-[13px] w-[13px]' +
          (i > pline ? " text-brand-200" : "") + '" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
      }

      var chip = document.createElement("span");
      chip.setAttribute("data-demo-stele", "");
      chip.className = "absolute bottom-3 left-3 flex items-center gap-1.5 rounded-full bg-white/90 py-1 pl-2.5 pr-3 shadow-soft backdrop-blur";
      chip.innerHTML = '<span class="flex items-center gap-0.5 text-gold-500">' + stele + "</span>" +
        '<span class="text-xs font-medium text-ink-muted">(' + d.cate + ")</span>";
      cutie.appendChild(chip);
    });
  }

  /* Pregatim pagina inainte de clic.
     Cand degetul atinge un link, sau cand mouse-ul intra peste el, cerem deja
     pagina in fundal. Pana ridici degetul, e adesea gata in memoria browserului,
     iar trecerea se simte instantanee. */
  function initPrefetch() {
    /* Respectam economia de date si conexiunile foarte lente. */
    var conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ""))) return;

    var cerute = {};

    function potrivit(a) {
      if (!a || !a.href) return false;
      if (a.origin !== window.location.origin) return false;
      if (a.hasAttribute("download") || a.target === "_blank") return false;
      var p = a.pathname;
      /* Coșul, contul și finalizarea se schimbă de la o secundă la alta. */
      if (/^\/(cart|checkout|account)/.test(p)) return false;
      if (p === window.location.pathname) return false;
      return true;
    }

    function pregateste(e) {
      var a = e.target.closest && e.target.closest("a[href]");
      if (!potrivit(a)) return;
      var url = a.href.split("#")[0];
      if (cerute[url]) return;
      cerute[url] = true;
      var l = document.createElement("link");
      l.rel = "prefetch";
      l.href = url;
      l.as = "document";
      document.head.appendChild(l);
    }

    document.addEventListener("pointerenter", pregateste, { capture: true, passive: true });
    document.addEventListener("touchstart", pregateste, { capture: true, passive: true });
  }

  /* Imaginea produsului pe tot ecranul.
     Se deschide din cadrul galeriei, arata poza la forma ei reala si se
     navigheaza cu sagetile, cu tastele sau cu degetul. */
  function initLightbox() {
    var box = $("[data-lightbox]");
    var galerie = $("[data-gallery]");
    if (!box || !galerie) return;

    var poze = $$("[data-gallery-image]", galerie);
    if (!poze.length) return;

    var img = $("[data-lightbox-image]", box);
    var contor = $("[data-lightbox-count]", box);
    var index = 0;

    function arata(i) {
      index = (i + poze.length) % poze.length;
      var sursa = poze[index];
      img.src = sursa.getAttribute("data-gallery-full") || sursa.src;
      img.alt = sursa.alt || "";
      if (contor) contor.textContent = index + 1 + " din " + poze.length;
    }

    function deschide() {
      /* Pornim de la imaginea afisata acum in galerie. */
      var activ = 0;
      poze.forEach(function (p, i) {
        if (!p.classList.contains("opacity-0")) activ = i;
      });
      arata(activ);
      box.hidden = false;
      scrollLock.on();
      requestAnimationFrame(function () {
        box.classList.remove("opacity-0", "pointer-events-none");
      });
    }

    function inchide() {
      box.classList.add("opacity-0", "pointer-events-none");
      scrollLock.off();
      setTimeout(function () { box.hidden = true; }, 300);
    }

    $("[data-gallery-open]").addEventListener("click", function (e) {
      /* Sagetile galeriei nu deschid fereastra, ele doar schimba imaginea. */
      if (e.target.closest("[data-gallery-prev], [data-gallery-next]")) return;
      deschide();
    });

    $$("[data-lightbox-close]", box).forEach(function (b) {
      b.addEventListener("click", inchide);
    });
    var prev = $("[data-lightbox-prev]", box);
    var next = $("[data-lightbox-next]", box);
    if (prev) prev.addEventListener("click", function () { arata(index - 1); });
    if (next) next.addEventListener("click", function () { arata(index + 1); });

    document.addEventListener("keydown", function (e) {
      if (box.hidden) return;
      if (e.key === "Escape") inchide();
      if (e.key === "ArrowLeft") arata(index - 1);
      if (e.key === "ArrowRight") arata(index + 1);
    });

    /* Glisare cu degetul intre imagini */
    var x0 = null;
    box.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 45) arata(index + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* --------------------------------------------------------------- alte */

  function initMisc() {
    var recoverToggle = $("[data-recover-toggle]");
    var recoverForm = $("[data-recover-form]");
    if (recoverToggle && recoverForm) {
      recoverToggle.addEventListener("click", function (e) {
        e.preventDefault();
        recoverForm.classList.toggle("hidden");
      });
    }
  }

  /* ---------------------------------------------------------------- boot */

  function boot() {
    initReveal();
    initHeader();
    initAnnouncement();
    initPromo();
    initScrollers();
    initHero();
    initCompare();
    initCart();
    initProduct();
    initReels();
    initCountdowns();
    initInViewVideos();
    initCampaignBar();
    initCookieConsent();
    initPrefetch();
    initReviewsDemo();
    initLightbox();
    initReviews();
    initMisc();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* reinițializare după editările din Theme Editor */
  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:select", boot);
})();
